<template>
	<wrapper :calculations="true">
		<template slot="wrapper">
			<div class="o-shell">
				<app-header :compact="true" />

				<main class="o-main">
					<step
						v-for="(step, index) in steps"
						:key="index"
						:stepIndex="index"
						:data="step"
						:activePart="currentStepPart"
						v-if="index === currentStep"
					/>

					<progress-bar
						:currentStep="currentStep"
						:currentStepPart="currentStepPart"
						:currentStepParts="currentStepParts"
						:onPrev="handlePrev"
						:onNext="handleNext"
						:maxSteps="steps.length - 1"
					/>
				</main>
			</div>
		</template>
	</wrapper>
</template>

<script>
import Header from 'components/header/header.vue';
import Row from 'components/row/Row.vue';
import Title from 'components/title/Title.vue';
import Progress from 'components/progress/Progress.vue';
import Wrapper from 'components/wrapper/Wrapper.vue';
import Step from 'components/step/Step.vue';
import steps from '../data';

export default {
	components: {
		'app-header': Header,
		row: Row,
		'row-title': Title,
		'progress-bar': Progress,
		wrapper: Wrapper,
		step: Step,
	},

	data() {
		return {
			currentStep: 0,
			currentStepPart: 0,
			steps,
		};
	},

	computed: {
		currentStepParts() {
			return this.steps[this.currentStep].rows.length;
		},
	},

	methods: {
		handlePrev() {
			if (this.currentStepPart !== 0) {
				this.currentStepPart--;
				return;
			}

			this.currentStep !== 0 && this.currentStep--;
			this.currentStepPart = this.steps[this.currentStep].rows.length - 1;
		},

		handleNext() {
			if (
				this.currentStepPart <
				this.steps[this.currentStep].rows.length - 1
			) {
				this.currentStepPart++;
				return;
			}
			this.currentStepPart = 0;
			this.currentStep++;
		},
	},

	created() {
		this.steps = this.steps.map((step, stepIndex) => {
			let dynamicRowID = 0;
			step.rows = step.rows.map((group, groupIndex) => {
				return group.map((row, rowIndex) => {
					row.id = dynamicRowID;
					row.subStepIndex = groupIndex;
					row.stepIndex = stepIndex;

					dynamicRowID++;
					return row;
				});
			});
			return step;
		});
	},
};
</script>

<style lang="scss" scoped>
.o-shell {
	max-width: 1366px;
	padding: 0 7% 5% 7%;

	@media (max-width: 1300px) {
		padding: 0 2% 5% 2%;
	}
}
</style>
